import { storeProvider, NoStoreError } from 'ReduxHelpers';
import { breadcrumbNavigationActions, selectBreadcrumbs } from './breadcrumbNavigationSlice';

type PopBreadcrumbsParams = {
    section: string;
    default: string;
    filter: (path: string) => boolean;
    currentPath: string;
};

/**
 * Pops items from a breadcrumb stack until it finds a path that both differs from the current location
 * and passes the provided filter. Updates the stored breadcrumbs and returns the destination path.
 * Falls back to the provided default when no path matches.
 */
export function popBreadcrumbs({ section, default: defaultPath, filter, currentPath }: PopBreadcrumbsParams): string {
    const store = storeProvider.store;
    if (!store) {
        throw new NoStoreError('BreadcrumbNavigation.popBreadcrumbs');
    }

    const state = store.getState();
    const breadcrumbs = [...selectBreadcrumbs(section)(state)];
    const normalizedCurrentPath = currentPath ?? '';

    while (breadcrumbs.length > 0) {
        const candidate = breadcrumbs.pop()!;
        if (candidate !== normalizedCurrentPath && filter(candidate)) {
            store.dispatch(breadcrumbNavigationActions.setBreadcrumbs({ section, paths: [...breadcrumbs] }));
            return candidate;
        }
    }

    store.dispatch(breadcrumbNavigationActions.clearBreadcrumbs({ section }));
    return defaultPath;
}
